import 'owl.carousel';
import 'owl.carousel2.thumbs';

export default {
  init($) {
    // JavaScript to be fired on all pages
  },
  finalize($) {
    // JavaScript to be fired on all pages, after page specific JS is fired
    setTimeout(() => {$('html').css('margin-top', '0') }, 500);

    $('.menu-item-has-children').on('mouseover', (e) => {
      $('.menu-item-has-children').find('ul.sub-menu').slideDown().show();
    });

    $('.menu-item-has-children').on('mouseleave', (e) => {
      $('.menu-item-has-children').find('ul.sub-menu').slideUp(400, () => { $('.menu-item-has-children').find('ul.sub-menu').hide(); });
    });

    $('#header-video-modal, #video-modal').on('show.bs.modal', function (e) {
      let button = $(e.relatedTarget); // Button that triggered the modal
      let url = button.data("video-url");
      $('#header-video-modal iframe, #video-modal iframe').attr('src', url)
    });

    $('#header-video-modal, #video-modal').on('hidden.bs.modal', function () {
      $('#header-video-modal iframe, #video-modal iframe').removeAttr('src');
    });

    $('#member-modal').on('show.bs.modal', function (e) {
      const $memberArea = $(e.relatedTarget); // Button that triggered the modal

      $('#member-modal .wrap-content').html($memberArea.find('.wrap-content').html());
      $('#member-modal .profile-info').html($memberArea.find('.profile-info').html());
    });

    $('#member-modal').on('hidden.bs.modal', function (e) {
      $('#member-modal .wrap-content').html('');
      $('#member-modal .profile-info').html('');
    });

    $('.mobile-menu-toggle').on('click', function () {
      $('.header').toggleClass('show-menu');
    });

    // Alejandria page home
    $(document).ready(function(){
      $('.gallery-slider').owlCarousel({
        autoplay: true,
        autoplayTimeout: 4000,
        loop: true,
        center: true,
        margin: 20,
        dots: false,
        thumbs: true,
        thumbImage: false,
        thumbsPrerendered: true,
        thumbContainerClass: 'owl-thumbs',
        thumbItemClass: 'owl-thumb-item',
        responsive : {
          0 : {
            items: 1,
          },
          768 : {
            items: 2,
          }
        }
      });

      $('.resources-slider').owlCarousel({
        autoplay: true,
        autoplayTimeout: 4000,
        loop: true,
        items: 3,
        dots: false,
        nav: true,
        navText: ["",""],
        responsive : {
          0 : {
            items: 1,
          },
          600 : {
            items: 2,
          },
          900 : {
            items: 3,
          }
        }
      });

      $('.testimonials-slider .owl-carousel').owlCarousel({
        //autoplay: true,
        autoplayTimeout: 4000,
        loop: true,
        items: 1,
        dots: false,
        nav: true,
        navText: ["",""]
      });


    });
  },
};
